<template>
   <div id="schedulerdb">
        <div class="row">
            <div class="col-12">
                  <MdTitle v-bind:Text="$t('schedulerDB.ScheDashboard')" />
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <MdButton
                              v-bind:Label="$t('Appointments.addAppointment')"
                              v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                              v-on:click="AddAppointment"
                              v-bind:IconClass="'ti-plus pr-1'"
                              v-bind:Name="'btn_add_appointment'"
                              v-bind:isReadOnly="!this.hasPermissionAdd()">
                            </MdButton>
                        </div>
                        <div class="col-sm-12 col-md-9 mb-4">
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                <div class="input-group" dir="ltr">
                                    <input type="text" :dir="dirInput" class="form-control" v-model="parameter.SearchCriteria" @keyup.enter="SearchAppoinments()">
                                        <div class="input-group-append">
                                            <MdButton
                                                v-bind:Name="'btnsearchinput'"
                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                v-on:click="SearchAppoinments">
                                            </MdButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>
        </div>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <!--<MdEdit
                    v-bind:Label="$t('Shared.datefrom')"
                    v-bind:TypeProp="'date'"
                    v-bind:Name="'DateFrom'"
                    v-model="DateFrom"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:Id="'input_schedulerdb_date_from'"
                    v-bind:OnPressEnter="SearchAppoinments">
                </MdEdit>-->
                <MdDateTime
                  :Label="$t('Shared.datefrom')"
                  :Model="DateFrom"
                  @input="DateFrom = $event"
                  :Id="'SchedulerDBDateFrom'"
                  :Type="'date'"
                  :OnPressEnter="SearchAppoinments"
                  :isRequired="false"
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <!--<MdEdit
                    v-bind:Label="$t('Shared.dateTo')"
                    v-bind:TypeProp="'date'"
                    v-bind:Name="'DateTo'"
                    v-model="DateTo"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:Id="'input_schedulerdb_date_to'"
                    v-bind:OnPressEnter="SearchAppoinments">
                </MdEdit>-->
                <MdDateTime
                  :Label="$t('Shared.dateTo')"
                  :Model="DateTo"
                  @input="DateTo = $event"
                  :Id="'SchedulerDBDateTo'"
                  :Type="'date'"
                  :OnPressEnter="SearchAppoinments"
                  :isRequired="false"
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$tc('Shared.Patient',2)"
                  v-bind:Options="PatientsList"
                  v-bind:Model="PatientVmodel"
                  v-bind:FieldDescription="'patientname'"
                  v-bind:FieldCode="'patientcode'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownPatients"
                  :CustomLabel="customLabelPatients"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$tc('Shared.Therapist')"
                  v-bind:Options="TherapistList"
                  v-bind:Model="TherapistVmodel"
                  v-bind:FieldDescription="'employeeName'"
                  v-bind:FieldCode="'employeeCode'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownTherapist"/>
            </b-col>
        </b-row>

        <b-row>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.AppointmentType')"
              v-bind:Options="AppoinmentTypeList"
              v-bind:Model="AppoinmentTypeVmodel"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Placeholder="selectPlaceholder"
              v-bind:Multiple="true"
              v-bind:RequireEvent="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownAppoinmentType"/>
        </b-col>

            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$tc('Shared.Program',2)"
                  v-bind:Options="ProgramsList"
                  v-bind:Model="ProgramsVmodel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'code'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownPrograms"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$t('Shared.AppotStatus')"
                  v-bind:Options="ApptStatusList"
                  v-bind:Model="ShowVmodel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownShow"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$t('Shared.NoteStatus')"
                  v-bind:Options="NoteStatusList"
                  v-bind:Model="NoteStatusVmodel"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="false"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownNoteStatus"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="useBranchLocations" md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$t('schedulerDB.AppointmentLocation')"
                  v-bind:Options="AppointmentLocationList"
                  v-bind:Model="AppointmentLocationVmodel"
                  v-bind:FieldDescription="'description'"
                  v-bind:FieldCode="'code'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownAppointmentLocation"/>
            </b-col>
						<b-col :md="useBranchLocations ? 9 : 12">
            <div class="text-center text-md-right mt-3">
                <button
                  v-on:click="SearchAppoinments()"
									type="button"
									class="btn btn-primary btn-login mx-2 pull-right"
									id="btnsearchinput">
										{{ $t('Shared.Search') }}
								</button>
							</div>
						</b-col>
				</b-row>
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" class="mt-2"/>

        <div class="row">
            <div class="col-md-3">
               <MdCheckBox
                v-bind:Label="$t('Shared.SelectAll')"
                v-bind:Name="'SelectTableAll'"
                v-bind:ClassProp="'AlignCheck mx-3'"
                v-bind:CheckedValue="true"
                v-bind:isReadOnly="this.items.length === 0"
                v-bind:UncheckedValue="false"
                v-model="UseSelectTableAll"
                v-on:change="onChangeSelectAll"
             />
            </div>
            <div class="col-md-3 mt-3">
              <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
            </div>
        </div>

        <MdTablePaginationClient
              v-bind:refTable="'AppntTable'"
              ref="AppntTable"
              v-bind:fields="fields"
              v-bind:isSchedulerDB="true"
              v-bind:items="items"
              v-bind:totalRows="totalRows"
              v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
              v-bind:currentPage="currentPage"
              v-bind:perPage="perPage"
              v-bind:ShowDetails="true"
              v-bind:SelectAll="UseSelectTableAll"
              v-bind:FieldsDate="FieldsDateArr"
              v-bind:pageOptions="pageOptions"
              v-bind:viewIconEvent="handleViewEvent"
              v-bind:IsEligibility="true"
              :ViewEligibility="ViewEligibility"
              v-bind:ondblClick="handleDblClick"
              v-bind:VisibleEditIcon="this.hasPermissionEdit()"
              v-bind:VisibleDeleteIcon="this.hasPermissionDelete()"
              :onFiltered="onFiltered"
              :pageChanged="pageChanged"
              :RowClick="RowClicked"
              :perPageFunction="PerPageFunction"
              :otherIcon="'printer-fill'"
              :otherIconEvent="showReport"
              :showTeleHealthIcon="true"
              :showUpIconEvent="ShowUpByRowItem">
            </MdTablePaginationClient>

            <div class="space-actions"></div>
        <div class="page-actions">
           <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
                <b-dropdown-item href="#" v-if="confirmStatus" v-on:click="ConfirmAppt('T')">{{$t('Shared.Confirm')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="uConfirmStatus" v-on:click="ConfirmAppt('F')">{{$t('Shared.uConfirm')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="showUp" v-on:click="ShowUpAppt('T')">{{$t('Shared.ShowUp')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="uShowUp" v-on:click="ShowUpAppt('F')">{{$t('Shared.uShowUp')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="cancel" v-on:click="OpenAppointmentReason('F')">{{$t('Shared.Cancel')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="uCancel" v-on:click="OpenAppointmentReason('T')">{{$t('Shared.uCancel')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="isNotify" v-on:click="ShowNotify()">{{$t('Shared.Notify')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="isEligible" v-on:click="doEligibility()">{{ $t('Check Eligibility') }}</b-dropdown-item>
                <b-dropdown-item href="#" v-if="isSchedulerNotes" v-on:click="GoToSchedulerNotes()">{{$t('Shared.SchedulerNotes')}}</b-dropdown-item>
                <b-dropdown-item href="#" v-on:click="ShowReport()">{{$t('Shared.Report')}}</b-dropdown-item>
            </b-dropdown>
        </div>

        <ModalAppointmentReason
          v-bind:TitleWindow="$t('AppointmentDashboard.ReasonForNoShow')"
          v-bind:ModalId="this.modalReasonId"
          v-bind:ClickedText="this.ClickedText"
        />
        <SchedulerSingleRep v-if="isReportVisible"
          :closeWindow="closeParamRepWindow"
          :activityId="paramActivityId"
          :useBranchLocations="useBranchLocations"
        />

        <SchedulerDailyRep v-if="isDailyReportVisible"
          :closeWindow="closeParamDailyReportWindow"
          :startDate="startDate"
          :useBranchLocations="useBranchLocations"
        />

        <ScheduleNotify v-if="isNotifyVisible"
          :onClose="closeNotifyWindow"
          :activityId="activityId"
          :module="'schedulerdb'"
          :onSuccess="notifySuccess"
        />

        <PatientAlertsInfoModal
            v-bind:PatientCode = "PatientCodeSelected"
            v-bind:AutoShow = "false"
            v-bind:ShowModal = "ShowModalPatientAlerts"
            v-bind:CloseEvent = "handleCloseEvent"
        >
        </PatientAlertsInfoModal>

        <b-toast id="progress-toast"
          variant="primary"
          solid
          auto-hide
          toaster="b-toaster-top-right">
                <div v-if="showProgressBar" id="ContainerProgress">
                    <MdProgress
                    v-bind:Label="progressLabel"
                    v-bind:Max="maxValue"
                    v-bind:ShowProgress="true"
                    v-model="progressValue"
                    v-bind:valueErr="ProgressValueErr"
                    />
                    <div v-if="progressLabel2" class="row">
                    <small class="col-12">
                        {{progressLabel2}}
                    </small>
                    </div>
                </div>
        </b-toast>


    </div>
</template>

<script>

import moment from 'moment'
import PatientService from '@/services/patient.service'
import CalendarResourcesService from '@/services/calendarresources.service'
import AppoinmentTypeService from '@/services/appointmenttypes.service'
import FacilitiesService from '@/services/facilities.service'
import ProgramService from '@/services/programs.services'
import AppointmentService from '@/services/appointment.service'
import PatientInsurance from '@/services/insurance.service'
import EligibilityService from '@/services/eligibility.service'
import Utils from '@/common/utils'
import EnumService from '@/services/enum.service'
import { EventBus } from '@/event-bus.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Permission from '@/common/Permission'
import ProviderService from '@/services/provider.service'
import BranchLocation from '@/services/branchlocation.service'

export default {
  mixins: [ShowMessage, DBFunctions, Permission],
  name: 'SchedulerDB',
  data(){
    return{
        parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,
        Status: '',
        Programs:'',
      },
      OptionsRightMenu:{
            visible:false,
            btnvisible:false,
            ItemsList:[],
            favButtonAtion: false
        },
      fullParam: {
            PageSize:0,
            PageNumber:0
        },
    PatientsList:[],
    TherapistList:[],
    AppoinmentTypeList:[],
    FacilitiesList:[],
    ProgramsList:[],
    NoteStatusList:EnumService.SchedulerDashboardNoteStatus,
    ApptStatusList:EnumService.SchedulerDashboardApptStatus,
    items:[],
    FieldsDateArr:['startDate','endDate'],
    PatientVmodel:"",
    NoteStatusVmodel:"",
    ShowVmodel:"",
    TherapistVmodel:"",
    AppoinmentTypeVmodel:"",
    FacilitiesVmodel:"",
    ProgramsVmodel:"",
    PatientSelected:"",
    FacilitieSelected:"",
    ProgramSelected:"",
    EmployeeSelected:"",
    ApptTypeSelected:"",
    ShowSelected:"",
    NoteStatusSelected:"",
    refTable: 'selectableTableSchedulerDB',
    ShowMessageIsEmpty:false,
    UseSelectTableAll:false,
    SelectedRecords:0,
    perPage: 10,
    SelectedPage : 0,
    totalRows: 0,
    currentPage: 1,
    pageOptions: [5, 10, 15 ],
    selectPlaceholder: this.$t('Shared.SelectOptions'),
    DateFrom: moment(this.NewDate).format("YYYY-MM-DD"),
    DateTo: moment(this.NewDate).format("YYYY-MM-DD"),
    fields:[
        { key: 'activityId', sortable: true, label: this.$t('Shared.Activity'), class: 'text-rigth hidden' },
        { key: 'startDate', sortable: true, label: this.$t('Shared.StartDate'), class: 'text-rigth' },
        { key: 'endDate', sortable: true, label: this.$t('Shared.EndDate'), class: 'text-rigth' },
        { key: 'appointmentTypeName', sortable: true, label: this.$tc('Shared.AppointmentType'), class: 'text-rigth' },
        { key: 'therapistName', sortable: true, label:  this.$tc('Shared.Therapist'), class: 'text-rigth' },
        { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
        { key: 'nickName', sortable: true, label: this.$t('Shared.NickName'), class: 'text-rigth' },
        { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
        { key: 'eligibilityDate', sortable: true, label: this.$t('Last Eligibility Checked'), class: 'text-rigth'},
        { key: 'primaryInsurance', sortable: true, label: this.$t('Shared.PrimaryInsurance'), class: 'text-rigth' },
        { key: 'dob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
        { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone'), class: 'text-rigth' },
        { key: 'dayPhone', sortable: true, label: this.$t('Shared.DayPhone'), class: 'text-rigth' },
        { key: 'nighTPhone', sortable: true, label: this.$t('Shared.NightPhone'), class: 'text-rigth' },
        { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },
        { key: 'programName', sortable: true, label: this.$tc('Shared.Program'), class: 'text-rigth' },
    ],
    confirmStatus: false,
    uConfirmStatus: false,
    showUp: false,
    uShowUp: false,
    cancel: false,
    uCancel: false,
    isNotify: false,
    isEligible: false,
    isSchedulerNotes: false,
    selected: [],
    indexSelected: 0,
    modalReasonId:"modalIdAppointmentReason",
    ClickedText:"",
    isReportVisible: false,
    paramActivityId: null,
    isDailyReportVisible: false,
    startDate: new Date(),
    isNotifyVisible: false,
    activityId: [],
    ShowModalPatientAlerts: false,
    PatientCodeSelected: '',
    currentItemSelected: null,
    dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    AppointmentLocationList: [],
    AppointmentLocationVmodel: '',
    useBranchLocations: false,
    LocationSelected:"",
    eligibilityObjList: [],
    monitorParam: {
      Guid: ""
    },
    timer: null,
    sec: 0,
    min: 0,
    hour: 0,
    progressLabel: '',
    showModalProgress: false,
    progressLabel2: '',
    modalButtonLabel: this.$t('Shared.BtnCancel'),
    cancelGuid: '',
    showProgressBar: true,
    isCompleted: false,
    progressValue: 0,
    ProgressValueErr: 0,
    maxValue: 0,
    failedList: '',
    buttonOK:true,
    }
  },

  methods:{

    ChangeDropDownAppointmentLocation(options) {
      this.AppointmentLocationVmodel = options;
      this.LocationSelected = "";
      var temp = [];
      options.forEach(function(e) {
        temp.push(e.code.trim());
      })
      this.LocationSelected = temp.join(',');
      this.SearchAppoinments();
    },

    async getProvider(){
      await ProviderService.ensureVisibleSettings()
            .then((state) => {
                this.useBranchLocations = state.useBranchLocations;
            })
         .catch(error => {
          if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }
         });

    },

    notifySuccess() {
      this.showMessage(this.$t('scheduleNotify.noti'),this.$t('scheduleNotify.msgSent'));
    },

    AddAppointment() {
      this.emitDataforFavorites();
      EventBus.$emit('onUpdatedMenu', '');
      this.$router.push({ name: 'appointmentDB-Editor-Add'});
    },

    ShowNotify() {
      this.isNotifyVisible = true
    },

    closeNotifyWindow() {
      this.isNotifyVisible = false
    },

    ShowReport() {
      this.isDailyReportVisible = true
    },

    closeParamDailyReportWindow() {
        this.isDailyReportVisible = false
      },

    tbodyRowAttr() {
			return {style: 'cursor: pointer'}
		},

    onRowClicked(item,index) {
      this.indexSelected = index
    },

    resetSelections() {
      this.selected = []
      this.SelectedRecords = 0;
      this.UseSelectTableAll = false
      this.showAllActions(false)
    },

    onChangeSelectAll(v){
      this.activityId = []
      if(v){
        this.SelectedRecords = this.items.length;
        this.selected = []
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true);
           this.selected.push(this.items[i])
           this.activityId.push(this.items[i].activityId)
        }
        this.showAllActions(true)
        if (this.selected.length === 1) {
          this.isSchedulerNotes = this.$store.state.isUseSchedulerClinical
        }
      }else{
        //this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
          this.$set(this.items[j], 'selected', false);
        }
        this.resetSelections()
      }
    },

    ChangeDropDownPatients(patients){
      this.PatientVmodel = patients;
      this.PatientSelected = "";
      var temp = [];
      patients.forEach(function(e) {
        temp.push(e.patientcode.trim());
      })
      this.PatientSelected = temp.join(',');
      this.SearchAppoinments();
    },

    ChangeDropDownTherapist(therapists){
      this.TherapistVmodel = therapists;
      this.EmployeeSelected = "";
      var temp = [];
      therapists.forEach(function(e) {
        temp.push(e.employeeCode.trim());
      })
      this.EmployeeSelected = temp.join(',');
      this.SearchAppoinments();
    },

    ChangeDropDownAppoinmentType(appttypes){
      this.AppoinmentTypeVmodel = appttypes;
      this.ApptTypeSelected = "";
      var temp = [];
      appttypes.forEach(function(e) {
        temp.push(e.code.trim());
      })
      this.ApptTypeSelected = temp.join(',');
      this.SearchAppoinments();
    },

    ChangeDropDownFacilities(facilities){
      this.FacilitiesVmodel = facilities;
      this.FacilitieSelected = "";
      var temp = [];
      facilities.forEach(function(e) {
        temp.push(e.code.trim());
      })
      this.FacilitieSelected = temp.join(',');
    },

    ChangeDropDownPrograms(programs){
      this.ProgramsVmodel = programs;
      this.ProgramSelected = "";
      var temp = [];
      programs.forEach(function(e) {
        temp.push(e.code.trim());
      })
      this.ProgramSelected = temp.join(',');
      this.SearchAppoinments();
    },

    ChangeDropDownNoteStatus(notestatus){
      this.NoteStatusVmodel = notestatus != null ? notestatus : "";
      this.NoteStatusSelected = notestatus != null ? notestatus.value : "";
      this.SearchAppoinments();
    },

    ChangeDropDownShow(options){
      this.ShowVmodel = options;
      this.ShowSelected = "";
      var temp = [];
      options.forEach(function(e) {
        temp.push(e.value.trim());
      })
      this.ShowSelected = temp.join(',');
      this.SearchAppoinments();
    },

    ViewIcon(row){
      this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.btnvisible = true;
        this.OptionsRightMenu.ItemsList = EnumService.AppointmentItems

        let layoutStatus = this.$store.state.layoutStatus;

        switch(layoutStatus) {
          case 'L0R0':
              this.$store.commit('setlayoutStatus', 'L0R1');
          break;
          default:
              this.$store.commit('setlayoutStatus', 'L1R1');
        }
        this.$emit('getVisibleMenu', this.OptionsRightMenu);

      this.$router.push({ name: "appointmentDB-Dashboard", params: { id: row.patientCode,actId:row.activityId } });
    },

    showAllActions(enabled) {
        this.confirmStatus = enabled
        this.uConfirmStatus = enabled
        this.showUp = enabled
        this.uShowUp = enabled
        this.cancel = enabled
        this.uCancel = enabled
        this.isNotify = enabled
        this.isEligible = enabled
        this.isSchedulerNotes = false
    },

    ConfirmAppt(opt){
      let param = {}
      let aIdList = []
      if (this.selected && this.selected.length == 1) {
        param = {
            ActivityIdList: this.selected[0].activityId,
            IsConfirmed: opt
        };
      } else if (this.selected && this.selected.length > 1) {
        this.selected.forEach(item => {
          aIdList.push(item.activityId);
        });
        param = {
            ActivityIdList: aIdList.toString(),
            IsConfirmed: opt
        };
      }

        AppointmentService.ConfirmAppt(param)
              .then(async (response) => {
                if(response.status == '200'){
                    if(param.IsConfirmed == 'F'){
                        this.$bvToast.toast(this.$t('Appointments.nConfirmMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                    }else{
                        this.$bvToast.toast(this.$t('Appointments.confirmMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                    }

                    await this.SearchAppoinments();
                    this.resetSelections()
                    //this.$refs.AppntTable.selectRow2(this.indexSelected)
                }
              })
              .catch(error => {
                /*if (!error.response) {
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
    },

    ShowUpByRowItem(item) {
        this.selected = [item]
        this.ShowUpAppt(item.status === 'Showed Up' ? 'F' : 'T')
    },

    ShowUpAppt(opt){
        let param = {};
        let aIdList = []

        if (this.selected && this.selected.length == 1) {
        param = {
            ActivityIdList : this.selected[0].activityId,
            State: opt,
            Action: opt == 'T' ? 'Show Up' : 'Undo Show Up',
        };

      } else if (this.selected && this.selected.length > 1) {
        this.selected.forEach(item => {
          aIdList.push(item.activityId);
        });
        param = {
            ActivityIdList: aIdList.toString(),
            State: opt,
            Action: opt == 'T' ? 'Show Up' : 'Undo Show Up',
        };
      }

         AppointmentService.ShowUp(param)
              .then( async (response) => {
                if(response.status == '200'){
                  //this.GetPermission(this.selected[0].activityId);
                   if(opt == 'T'){
                        this.$bvToast.toast(this.$t('Appointments.showUpMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                    }else{
                        this.$bvToast.toast(this.$t('Appointments.uShowUpMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                    }
                    await this.SearchAppoinments();
                    //this.$refs.AppntTable.selectRow2(this.indexSelected)
                    this.resetSelections()
                }
              })
              .catch(error => {
                /*if (!error.response) {
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
    },

    OpenAppointmentReason(opt){
      if (opt == 'F') {
        EventBus.$emit('onAppointmentReasonModal', opt);
      }
      else{
          this.CancelAppt(opt,'');
      }
    },

    CancelAppt(opt,reason){
        let param = {}
        let aIdList = []

        if (this.selected && this.selected.length == 1) {
          param.ActivityIdList = this.selected[0].activityId
        }
        else if (this.selected && this.selected.length > 1) {
          this.selected.forEach(item => {
            aIdList.push(item.activityId);
          });
          param = {
            ActivityIdList: aIdList.toString(),
          };
        }

        if(opt == 'F'){
            param.Reason = reason;
        }
        else{
            param.Reason = "";
        }

        if (param.ActivityIdList) {
          AppointmentService.CancelAppt(param)
              .then(async (response) => {
                if(response.status == '200'){
                    //this.GetPermission(this.selected[0].activityId);

                    if(opt == 'F'){
                        this.$bvToast.toast(this.$t('Appointments.cancelMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        });
                    }else{
                        this.$bvToast.toast(this.$t('Appointments.cancelUnDoneMsg'), {
                         title: this.$t('Msg.Info'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                    }

                    await this.SearchAppoinments();
                    //this.$refs.AppntTable.selectRow2(this.indexSelected)
                    this.resetSelections()
                }
              })
              .catch(error => {
                /*if (!error.response) {
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
        }
    },

    onFiltered(filteredItems){
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    pageChanged(){

    },

    RowClicked(item){
      if(item.selected){
        this.$set(item, 'selected', false);
      }else{
        this.$set(item, 'selected', true);
      }
        EventBus.$emit('rowClicked', item);

      let itemselected = this.selected.findIndex((element) => element.activityId == item.activityId)

      if (itemselected != -1 && !item.selected) {
        this.selected.splice(itemselected, 1)
        let aIdIndx = this.activityId.indexOf(item.activityId)
        this.activityId.splice(aIdIndx, 1)
      } else if (itemselected == -1 && item.selected) {
        this.selected.push(item)
        this.activityId.push(item.activityId)
      }

      if (this.selected && this.selected.length == 1) {
        this.confirmStatus = item.status == 'New' ? true : false
        this.uConfirmStatus = item.status == 'Confirmed' ? true : false
        this.showUp = item.status == 'New' || item.status == 'Confirmed' ? true : false
        this.uShowUp = item.status == 'Showed Up' ? true : false
        this.cancel = item.status == 'New' || item.status == 'Confirmed' ? true : false
        this.uCancel = item.status == 'Missed' ? true : false
        this.isNotify = true
        this.isEligible = true
        this.isSchedulerNotes = this.$store.state.isUseSchedulerClinical
      }
       else if (this.selected && this.selected.length > 0) {
        this.showAllActions(true)
        //this.activityId.push(item.activityId)
      } else {

        this.showAllActions(false)
      }
    },

    PerPageFunction(page){
      this.perPage = page;
    },

    getEmployees() {
        CalendarResourcesService.getAll(this.fullParam)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.TherapistList = response.data;
                }
              })
              .catch(error => {
                /*if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
            },

    getPatients(){
      PatientService.getAll(this.fullParam)
      .then((response) => {
       if(response.status == '200' && response.data && response.data.length > 0){
        this.PatientsList = response.data;
        this.PatientsList.forEach(function(element) {
            element.patientname = element.firstname + " " + element.lastname;
        });
        }
        this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        /*if (!error.response) {
            // network error
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
        } else {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
        }*/
       this.showResponseErrorMessage(error);
      });
    },

    getAppointmentTypes() {
        AppoinmentTypeService.getListing()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.AppoinmentTypeList = response.data;
                }
              })
              .catch(error => {
                /*if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
    },

    getFacilities() {
        FacilitiesService.getAll(this.fullParam)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.FacilitiesList = response.data;
                }
              })
              .catch(error => {
                /*if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }*/
               this.showResponseErrorMessage(error);
              });
    },

    getPrograms(){
      ProgramService.getAll(this.fullParam)
        .then((response) => {
          if(response.data && response.data.length > 0){
            this.ProgramsList = response.data;
          }
        })
        .catch(error => {
           this.showResponseErrorMessage(error);
        });
    },

    async SearchAppoinments(){
      var param = {
        PatientCode:this.PatientSelected,
        EmployeeCode:this.EmployeeSelected,
        AppointmentType:this.ApptTypeSelected,
        FacilityCode:this.FacilitieSelected,
        ProgramCode:this.ProgramSelected,
        NoteStatus:this.NoteStatusSelected,
        AppointmentStatus:this.ShowSelected,
        DateFrom:this.DateFrom,
        DateTo:this.DateTo,
        SearchCriteria: this.parameter.SearchCriteria,
        BranchLocation: this.LocationSelected
      }
      this.resetSelections()
      await AppointmentService.getAll(param)
        .then((response) => {
          if(response.data){
            this.items = response.data;
            this.totalRows = this.items.length;
            this.items.forEach(function(element) {
              let { dob, startDate, endDate, timeIn, timeOut, eligibilityDate } = element
              if (dob) element.dob = Utils.formatterDateToString(dob);
              if (startDate) element.startDate = `${Utils.formatterDateToString(startDate)} ${Utils.formatTimeWithoutFormat(timeIn)}`;
              if (endDate) element.endDate = `${Utils.formatterDateToString(endDate)} ${Utils.formatTimeWithoutFormat(timeOut)}`;

              if (eligibilityDate) element.eligibilityDate = Utils.formatterDateToString(element.eligibilityDate)
            });
            if (this.items.length === 0) {
							this.ShowMessageIsEmpty = true;
						}
          }

        })
        .catch(error => {

           this.showResponseErrorMessage(error);
        });
    },

    customLabelPatients ({ patientname, patientcode }) {
        return `${patientname} – ${patientcode}`
    }
    ,
    showReport(item) {
      if (item && item.activityId) {
        this.paramActivityId = item.activityId
      }
      this.isReportVisible = true
    },
    closeParamRepWindow() {
      this.isReportVisible = false
      this.paramActivityId = null
    },

    async handleViewEvent(item) {
        await this.handleDblClick(item)
    },

    async handleDblClick(item) {
        this.PatientCodeSelected = item.patientCode;
        const hasAlerts = await this.IsPatientWithActiveAlerts(this.PatientCodeSelected);
        if (hasAlerts) {
            this.currentItemSelected = item;
            this.ShowModalPatientAlerts = true;
        } else {
            this.ViewIcon(item);
        }
    },

    handleCloseEvent() {
        this.ShowModalPatientAlerts = false;
        if (this.currentItemSelected) {
            this.ViewIcon(this.currentItemSelected)
        }
    },

    branchLocation() {
      if(this.$store.state.branchlocationwasloaded){
            this.AppointmentLocationList = this.$store.state.branchlocationsList;
        }else{
            BranchLocation.GetBranchLocations()
            .then((response) => {
                 if(response.status == '200'){
                  this.AppointmentLocationList = response.data;
                  this.$store.commit('initBranchLocationList')
                  this.$store.commit('setBranchLocationwasloaded',true);
                  response.data.forEach(element => {
                    this.$store.commit('setBranchLocationList',element);
                  });
                 }
          })
           .catch((error) => {
               if (error.response) {
                 this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
           });
        }
    },

    async getPatientPrimaryInsurance() {
      if (this.selected.length === 0) return

      const requests = this.selected.map(item => {
        let params = {
          PatientCode: item.patientCode,
          Type: "P"
        }

        return PatientInsurance.getAllPatientInsurances(params)
          .then(response => {
            return {
              PatientCode: response.data[0].patientcode,
              InsuranceCode: response.data[0].insuranceCode,
              ServiceDate: new Date(Date.now()).toISOString()
            }
          })
      })

      const results = await Promise.all(requests)
      this.eligibilityObjList.push(...results)
    },


    async checkEligibility() {
      this.eligibilityObjList = []

      await this.getPatientPrimaryInsurance()

      const checks = this.eligibilityObjList.map(async item => {
        const response = await EligibilityService.checkEligible(item.InsuranceCode)
        item.isEligible = response.data
        return item
      })

      await Promise.all(checks)
    },


    async createGroupEligibility() {
      this.eligibilityObjList = []
      await this.getPatientPrimaryInsurance()
      //this.eligibilityObjList = this.eligibilityObjList.filter((e) => e.isEligible === true)
      console.log(this.eligibilityObjList)
      EligibilityService.createGroupEligibility(this.eligibilityObjList).then(response => {
        console.log(response.data)
        this.cancelGuid = response.data.guid
        this.maxValue = this.eligibilityObjList.length
        this.startProcess()
        this.$emit('load', false)
      }).catch((error) => {
          this.$emit('load', false);
          if(error.response.status === 400 ){
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }else{
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
      })
    },

    async doEligibility() {
      await this.createGroupEligibility()
    },

    async ViewEligibility(row) {
        this.$emit('load', true)
        let params = {}
        params.PatientCode = row.patientCode
        await PatientInsurance.getAllPatientInsurances({
          PatientCode: params.PatientCode,
          Type: "P"
        }).then(response => {
          params.InsuranceCode = response.data[0].insuranceCode
        })
        EligibilityService.getEligibilityHtml(params).then(response => {
          this.$emit('load', false)
          const blob = new Blob([response.data.eligibility.toString()], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        }).catch((error) => {
          this.$emit('load', false)
          console.log(error.response.data)
          this.showResponseErrorMessage(error.response.data.errorMessage)
        })
    },

    async startProcess() {
      this.sec = 0
      this.min = 0
      this.hour = 0
      this.buttonOK = true
      this.fileList = []
      this.failedList = ''
      this.progressValue = 0
      this.progressLabel2 = ''
      this.showProgressBar = true
      this.modalButtonLabel = this.$t('Shared.BtnCancel')
      this.progressLabel = this.$t('Processing')
      this.$emit('load', true);
      this.showModalProgress = true
      this.$bvToast.show('progress-toast')
      await this.runMonitor()
    },

    runMonitor() {
      this.timer = setInterval(()=> this.checkMonitor(), 2000)
    },

    checkMonitor() {
      this.sec+=2
      if(this.sec >= 59){
        this.sec = 0;
        this.min++;
      }
      if(this.min >= 59){
        this.min = 0;
        this.hour++;
      }
      this.monitorUploadReport()
      this.progressLabel =  `${this.$t('Processed')} ${this.progressValue} ${this.$t('rClinicalNotes.fOf')} ${this.maxValue - 1} ${this.$t('rClinicalNotes.tTimeElapsed')} ${this.getElapseTime(this.hour,this.min,this.sec)}`
    },

    getElapseTime(hour,min,sec) {
        const nSec = (sec <= 9)? sec="0"+sec : sec
        const nMin = (min <= 9)? min="0"+min : min
        const nHour = (hour <= 9)? hour="0"+hour : hour
        return `${nHour}:${nMin}.${nSec}`
    },

    monitorUploadReport() {
            let counterDone = 0
            let counterFail = 0
            this.monitorParam.Guid = this.cancelGuid
            console.log(this.monitorParam)
            this.failedList = "";
            EligibilityService.monitorEligibility(this.monitorParam)
            .then((response) => {
                if(response.status == '200' && response.data) {
                    console.log(response.data)
                    counterDone = this.maxValue - response.data.remaining
                    this.progressValue = counterDone
                    this.ProgressValueErr = counterFail

                    if (response.data.done) {
                        let created = response.data.totalCount - response.data.failedCount;
                        this.failedList += `Number of reports created: ${created}\n\n`
                        this.failedList += `${this.$t('Time elasped')} ${this.getElapseTime(this.hour,this.min,this.sec)}\n\n`
                        this.failedList += response.data.errorMessage ? `Error: `+response.data.errorMessage : ``;
                        if(response.data.errorMessage) {
                          this.showMessage(this.$t('Eligibility Report'), "Some errors need to be checked", "warning")
                        }
                        this.showMessage(this.$t('Eligibility Report'),"Finish generating eligibility reports", "success")
                        this.stopProgress();
                    }
                }
            })
            .catch((error) => {
                /*if (!error.response) {
                // network error
                this.stopProgress(this.$t('Msg.retrieveInfo'))
                } else {
                this.stopProgress(error)
                }*/
                this.showResponseErrorMessage(error);
            });
    },

    stopProgress(msg) {
      clearInterval(this.timer)
      this.sec = 0
      this.min = 0
      this.hour = 0
      this.fileList = []
      this.failedList += msg ? `${msg}\n\n` : ''
      this.progressLabel2 = ''
      this.modalButtonLabel = this.$t('Shared.Close')
      this.isCompleted = true;
      this.showProgressBar = false;
      this.SearchAppoinments()
    },

    GoToSchedulerNotes() {
      if (this.selected.length === 1) {
        const item = this.selected[0]
        this.$router.push({
          name: 'appointmentDB-notes',
          params: { id: item.patientCode, actId: item.activityId }
        }).catch(() => {})
      }
    },

    handleOk(){
      if(!this.isCompleted){
        //this.CancelUpload();
      }
      this.showModalProgress = false;
    },
  },

  created(){
    this.getPatients();
    this.getEmployees();
    this.getAppointmentTypes();
    this.getFacilities();
    this.getPrograms();
    this.getProvider()
    this.branchLocation()

    EventBus.$on("rowClicked", function () {
    this.SelectedRecords = 0;
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }

     }.bind(this));

    EventBus.$on("onAppointmentReasonModal", function (reason) {
			this.ClickedText  = reason;
			this.$bvModal.show(this.modalReasonId);
		}.bind(this));

    EventBus.$on("onSelectAppointmentReasonCode", function (param) {
      this.CancelAppt(param.Text, param.Code);
    }.bind(this));
  },

  mounted(){
    this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = true;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

      this.SearchAppoinments();
  },

  destroyed(){
    EventBus.$off('onAppointmentReasonModal');
    EventBus.$off('onSelectAppointmentReasonCode');
  }

};
</script>


